import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageTitle } from "@/contexts/page-title-context";
function AdminLoadsLayout({ children }: { children: React.ReactNode }) {
  const { t: tAdminLoadApprovals } = useTranslation("admin.loadApprovals");

  return (
    <>
      <PageTitle>{tAdminLoadApprovals("title")}</PageTitle>
      {children}
    </>
  );
}

export const Route = createFileRoute("/_app/admin/loads")({
  component: function LayoutRoute() {
    return (
      <AdminLoadsLayout>
        <Outlet />
      </AdminLoadsLayout>
    );
  },
});
